import { render, staticRenderFns } from "./ide.vue?vue&type=template&id=66bfba1f"
import script from "./ide.vue?vue&type=script&lang=js"
export * from "./ide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports